import { render, staticRenderFns } from "./recuperarSenha.vue?vue&type=template&id=1ef3d3b0&scoped=true"
import script from "./recuperarSenha.vue?vue&type=script&lang=js"
export * from "./recuperarSenha.vue?vue&type=script&lang=js"
import style0 from "./recuperarSenha.vue?vue&type=style&index=0&id=1ef3d3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef3d3b0",
  null
  
)

export default component.exports